/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { IAttrStyled } from '../../../../types/globalTypes';
import { IStyledProps } from '../TextBlock';

const TextContainerStyled = styled.span.attrs((props: IStyledProps) => ({
    className: `text-block ${props.className}`,
})) <IStyledProps & IAttrStyled>`
    margin: 0;
    ${(props) => props.font};
    ${(props) => (
        props.defaultColor
        && props.children === props.defaultValue
        ? `color: ${props.defaultColor};`
        : ''
    )}

    &.link {
        cursor: pointer;
    }
`;
TextContainerStyled.defaultProps = {
    className: '',
};

export {
    TextContainerStyled,
};
